@if (!errorAddingUser) {
	<div class="pop-up-dialog-v2" [ngClass]="{ 'pop-up-dialog-confirmed-v2': step === 1 }">
		@if (step === 0) {
			<h3 i18n="@@reactivateUser-reactivateUserHeader">Reactivate</h3>
		}
		@if (step === 1) {
			<h3 i18n="@@reactivateUser-userReactivatedHeader">User Reactivated</h3>
		}
		<mat-divider></mat-divider>
		@if (step === 1) {
			<div class="check-icon-container">
				<mat-icon svgIcon="sl-check" class="check-icon"></mat-icon>
			</div>
		}
		@if (step === 0) {
			<mat-dialog-content>
				<div>
					<ng-container i18n="@@reactivateUser-pleaseConfirm">Please confirm you want to reactivate</ng-container
					><ng-container>&nbsp;</ng-container> <b>{{ listOfUserNames }}</b> <ng-container>&nbsp;</ng-container
					><ng-container i18n="@@reactivateUser-to">to</ng-container><ng-container>&nbsp;</ng-container>
					<b>{{ data.company.name }}</b
					>.
					<span [ngPlural]="data.users.length">
						<ng-template i18n="@@reactivateUser-userSingular" ngPluralCase="=1">This user's</ng-template
						><ng-container>&nbsp;</ng-container>
						<ng-template i18n="@@reactivateUser-userPlural" ngPluralCase="other">These users'</ng-template
						><ng-container>&nbsp;</ng-container>
					</span>
					<ng-container i18n="@@reactivateUser-capabilitiesReactivated"
						>capabilities will be reactivated and a registration email will be sent out again whether they were pending
						or active at the time of their deactivation.</ng-container
					>
				</div>
			</mat-dialog-content>
		}
		@if (step === 1) {
			<mat-dialog-content>
				<div>
					{{ listOfUserNames }}
					<ng-container i18n="@@reactivateUser-successfullyReactivated"
						>has been successfully reactivated as a</ng-container
					><ng-container>&nbsp;</ng-container> <b>{{ data.roleName }}</b
					>. <ng-container i18n="@@reactivateUser-nowActive">They are now active and associated with</ng-container
					><ng-container>&nbsp;</ng-container> <b>{{ data.company.name }}</b
					>.
				</div>
			</mat-dialog-content>
		}
		@if (step === 0) {
			<mat-dialog-actions>
				<button
					(click)="onCloseClicked(false)"
					class="secondary-small-button"
					i18n="@@reactivateUser-reactivateUserDialogCancel"
					data-automation-id="reactivate-user-cancel-button"
				>
					Cancel
				</button>
				<button
					(click)="onAddClicked()"
					class="primary-small-button"
					i18n="@@reactivateUser-reactivateUserDialogConfirm"
					data-automation-id="reactivate-user-confirm-button"
				>
					Confirm
				</button>
			</mat-dialog-actions>
		}
		@if (step === 1) {
			<mat-dialog-actions>
				<button
					(click)="onCloseClicked(true)"
					class="primary-small-button"
					i18n="@@reactivateUser-reactivateUserDialogClose"
					data-automation-id="reactivate-user-close-button"
				>
					Close
				</button>
			</mat-dialog-actions>
		}
	</div>
}

@if (errorAddingUser) {
	<div class="pop-up-dialog-v2">
		<h3 i18n="@@reactivateUser-errorAddingUserHeader">Error!</h3>
		<mat-divider></mat-divider>
		<mat-dialog-content>
			<div>
				<ng-container i18n="@@reactivateUser-unableReactivate">Unable to reactivate the</ng-container
				><ng-container>&nbsp;</ng-container>
				<span [ngPlural]="data.users.length">
					<ng-template i18n="@@reactivateUser-userLowerCase" ngPluralCase="=1">user</ng-template
					><ng-container>&nbsp;</ng-container>
					<ng-template i18n="@@reactivateUser-usersLowerCase" ngPluralCase="other">users</ng-template
					><ng-container>&nbsp;</ng-container>
				</span>
				<ng-container i18n="@@reactivateUser-pleaseTryAgain">at this time. Please try again.</ng-container>
			</div>
		</mat-dialog-content>
		<mat-dialog-actions>
			<button
				(click)="onCloseClicked(false)"
				class="primary-small-button"
				i18n="@@reactivateUser-errorAddingUserConfirm"
				data-automation-id="reactivate-user-ok-button"
			>
				Ok
			</button>
		</mat-dialog-actions>
	</div>
}
